import { create } from 'zustand'
import type { SlideInsertPrefill } from './types'
export type { SlideInsertPrefill } from './types'
export const useSlideInsertState = create<{
  prefill: SlideInsertPrefill | null
  open: (prefill?: SlideInsertPrefill) => void
  close: () => void
}>((set) => ({
  prefill: null,
  open: (prefill = {}) => set({ prefill }),
  close: () => set({ prefill: null }),
}))
/** Public entry for all callers, including the separately maintained card window. */
export function useSlideInsertModal(): { open(prefill?: SlideInsertPrefill): void } {
  return { open: useSlideInsertState((state) => state.open) }
}
